import { Navigate, Outlet } from 'react-router-dom'

import { useAuthStore } from '@/stores/auth'

import { paths } from '@/config/paths'

import { useHasActiveMembership, useHasPausedMembership, useIsMember } from '@/hooks/useMembership'

/**
 * Route guard that checks if a member has an active membership.
 * Members without active membership are redirected to select-plan page.
 * This guard only applies to members - other roles pass through normally.
 */
export default function MembershipProtectedRoute() {
  const user = useAuthStore((state) => state.user)
  const isMember = useIsMember()
  const hasActiveMembership = useHasActiveMembership()
  const hasPausedMembership = useHasPausedMembership()

  if (!user) return <Navigate to={paths.public.auth.login.path} replace />

  // Only apply membership check to members
  if (isMember && !hasActiveMembership) {
    // If membership is paused, redirect to unauthorized
    if (hasPausedMembership) {
      return <Navigate to={paths.public.unauthorized.path} replace />
    }
    // Otherwise redirect to plan selection
    return <Navigate to={paths.dashboard.member.selectPlan.path} replace />
  }

  return <Outlet />
}
